import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Field,
  reduxForm,
} from 'redux-form';
import { Card, CardBody, Col } from 'reactstrap';
import TextBox from '../../../shared/components/form/TextBox';
import renderSelectField from '../../../shared/components/form/Select';
import renderDatePickerField from '../../../shared/components/form/DatePicker';
import setPropsAsInitialValues from '../../../helpers/setPropsAsInitialValues';
import validate from './validate';

class StudentForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    users: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    mallas: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  }

  static defaultProps = {
    submitting: false,
  }

  render() {
    const {
      submitting,
      handleSubmit,
      onBack,
      users,
      mallas,
    } = this.props;
    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <Form className="form" onSubmit={handleSubmit}>
              <div className="card__title">
                <h5 className="bold-text">Datos del alumno</h5>
              </div>

              <div className="form__form-group">
                <span className="form__form-group-label required">N&uacute;mero de Legajo</span>
                <div className="form__form-group-field">
                  <Field
                    name="numeroLegajo"
                    component={TextBox}
                    type="number"
                    placeholder="N&uacute;mero de Legajo"
                  />
                </div>
              </div>

              <div className="form__form-group">
                <span className="form__form-group-label required">Alumno</span>
                <div className="form__form-group-field">
                  <Field
                    name="usuario"
                    component={renderSelectField}
                    placeholder="Alumno"
                    autoComplete="false"
                    options={users}
                  />
                </div>
              </div>

              <div className="form__form-group">
                <span className="form__form-group-label required">Malla - Carrera</span>
                <div className="form__form-group-field">
                  <Field
                    name="malla"
                    component={renderSelectField}
                    placeholder="Malla - Carrera"
                    autoComplete="false"
                    options={mallas}
                  />
                </div>
              </div>

              <div className="form__form-group">
                <span className="form__form-group-label required">Fecha de ingreso</span>
                <div className="form__form-group-field">
                  <Field
                    name="fechaIngreso"
                    component={renderDatePickerField}
                    placeholder="Fecha de ingreso"
                  />
                </div>
              </div>

            </Form>
            <div className="card__title">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={submitting}
                onClick={handleSubmit}
              >Guardar
              </button>
              <button
                type="submit"
                className="btn btn-outline-secondary"
                onClick={onBack}
              >Cancelar - Volver
              </button>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

const StudentFormForm = reduxForm({
  form: 'StudentFormForm',
  validate,
  enableReinitialize: true,
})(StudentForm);

export default setPropsAsInitialValues(StudentFormForm);
